import { isInstagramLead } from "features/Crm/utils/Crm.utils";

const hasValidPhoneNumber = (phoneNumber) =>
  Boolean(phoneNumber && phoneNumber !== "null");

const getProfilePicture = (profile) => {
  if (!profile) return null;

  return (
    profile.profile_pic ??
    profile.profile_picture_url ??
    profile.profile_image_url ??
    profile.image_url ??
    profile.image ??
    profile.dp ??
    profile.avatar ??
    null
  );
};

export const getContactInstagramUnread = (contact) =>
  contact?.instagramUnread ?? false;

export const getContactProfilePic = (contact) => {
  if (!contact) return null;

  const directPic = contact.profile_pic?.trim?.() || contact.profile_pic;
  if (directPic) return directPic;

  return getProfilePicture(contact.profile);
};

export const getContactSearchSubtitle = (contact) => {
  if (!contact) return "";

  if (contact.email) return contact.email;

  if (hasValidPhoneNumber(contact.phone_number)) {
    const countryCode = contact.country_code ?? "";
    return `${countryCode} ${contact.phone_number}`.trim();
  }

  if (isInstagramLead(contact)) {
    const username =
      contact.instagram_username ??
      contact.profile?.username ??
      contact.username;

    if (username) {
      return username.startsWith("@") ? username : `@${username}`;
    }
  }

  return "";
};

export const mapInboxContact = (contact) => {
  if (!contact) return contact;

  return {
    ...contact,
    instagramUnread: getContactInstagramUnread(contact),
  };
};

export const getContactsListFiltersParams = (
  unreadApplied,
  openApplied,
  selectedOrgIds
) => {
  return {
    ...(unreadApplied ? { unread: unreadApplied } : {}),
    ...(openApplied ? { active_window: openApplied } : {}),
    ...(selectedOrgIds?.length ? { org_ids: selectedOrgIds?.join(",") } : {}),
  };
};
